import { z } from 'zod';

export const ITEM_STATUS_SCHEDULING_TYPE = {
  UNSPECIFIED: 'UNSPECIFIED',
  SCHEDULED: 'SCHEDULED',
  UNSCHEDULED: 'UNSCHEDULED',
  DONE: 'DONE',
} as const;

export const itemStatusSchedulingTypeSchema = z.enum(ITEM_STATUS_SCHEDULING_TYPE);

export const itemStatusSchema = z.object({
  id: z.number().int().positive(),
  schedulingType: itemStatusSchedulingTypeSchema,
  name: z.string(),
  color: z.string(),
  priority: z.string(),
  isDefault: z.boolean(),
  archivedAt: z.number().int().optional(),
});

export const itemStatusDisplaySchema = z.object({
  id: z.number().int().positive(),
  schedulingType: itemStatusSchedulingTypeSchema,
  name: z.string(),
  color: z.string(),
});

export type ItemStatusSchedulingType = z.infer<typeof itemStatusSchedulingTypeSchema>;
export type ItemStatusDTO = z.infer<typeof itemStatusSchema>;
export type ItemStatusDisplayDTO = z.infer<typeof itemStatusDisplaySchema>;
